// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"c1cb9ab4","149":"9a369aa8","787":"5b77443d","845":"1a29024d"}[chunkId] + ".chunk.js";
};